function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n            .cls-hat1,.cls-hat2{fill:#fff !important}.cls-1{font-size:7px;font-family:OpenSans-Semibold,Open Sans;font-weight:600}\n        "));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "hat",
  transform: "translate(-158 -293)"
}, React.createElement("text", {
  id: "HAT-2",
  fill: "fff",
  className: "cls-1 cls-hat1",
  "data-name": "HAT",
  transform: "translate(159 310)"
}, React.createElement("tspan", {
  x: 0,
  y: 0
}, "HAT")), React.createElement("g", {
  id: "hat-3",
  "data-name": "hat",
  transform: "translate(158 293)"
}, React.createElement("path", {
  id: "Path_25",
  d: "M83.269 88.49c3.826 0 4.592-1.516 4.586-1.518-.555-6.361-3.92-2.779-4.586-2.779s-4.032-3.581-4.586 2.779c-.006.002.76 1.518 4.586 1.518z",
  className: "cls-2 cls-hat2",
  "data-name": "Path 25",
  transform: "translate(-76.269 -83.188)"
}), React.createElement("path", {
  id: "Path_26",
  d: "M12.34 223.72a3.118 3.118 0 0 1-1.549 1.267A9.523 9.523 0 0 1 7 225.7a9.523 9.523 0 0 1-3.791-.709 3.118 3.118 0 0 1-1.549-1.271c-1.035.458-1.66 1.052-1.66 1.7 0 1.452 3.134 2.629 7 2.629s7-1.177 7-2.629c0-.648-.625-1.242-1.66-1.7z",
  className: "cls-2 cls-hat2",
  "data-name": "Path 26",
  transform: "translate(0 -219.649)"
})));

var SvgHat = function SvgHat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hat.a72eb957.svg";
export { ForwardRef as ReactComponent };